import React from 'react';
import { Box, HStack } from 'native-base';
import { UserGroup, ChatStreak } from '../../';

// Classes & Types
import { Streak } from '@breakroom-nx/classes';
import { RoomMember } from '@breakroom-nx/helpers';

interface ChatHeaderProps {
  members?: RoomMember[];
  created: Date;
  expires: Date;
  streak: Streak;
  isLoading?: boolean;
}
export function ChatHeader({
  members,
  created,
  expires,
  streak,
  isLoading = true,
}: ChatHeaderProps) {
  return (
    <Box borderBottomWidth={1} borderColor={'surface.200'}>
      <HStack direction={'row'} px={10} pb={5} justifyContent={'space-between'}>
        <UserGroup members={members} compressed={true} loading={isLoading} />
        <ChatStreak created={created} expires={expires} streak={streak} />
      </HStack>
    </Box>
  );
}

export default React.memo(ChatHeader);
